<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	import {getShenBaoDiscount} from '../../../../../../api/Draftgeneration.js'
	export default {
		name: '',
		components: {},
		props: {
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			showpz: { 
				type: Boolean,
				default: false
			},
			tableDataI: {
				type: Array,
				default: [],
			},
			tableDataII: {
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
			params: {
				type: Object,
				default: {}
			},
		},
		data: function() {
			return {
				headDataI: getdata().headDataI,
				headDataII: getdata().headDataII,
				jsoptions:[],
				msoptions:[],
				jsoptionsArr:[],
				msoptionsArr:[]
			};
		},
		created() {
			this.getShenBaoDiscount()
		},
		methods: {
			getShenBaoDiscount(){
				getShenBaoDiscount({
					id:this.params.id
				}).then(res=>{
					this.jsoptionsArr=res.data.data.jians
					this.msoptionsArr=res.data.data.mians
					this.jsoptions=res.data.data.jians
					this.msoptions=res.data.data.mians
				
				})
			},
			inputblur(e){
			let jsoptionsfilter=this.tableDataI.map(item=>item.zzs_6_x_0.cellVal)
			let msoptionsfilter=this.tableDataII.map(item=>item.zzs_6_x_0.cellVal)
			this.jsoptions=this.jsoptionsArr.filter(gtem=>!jsoptionsfilter.includes(gtem.code))
			this.msoptions=this.msoptionsArr.filter(gtem=>!msoptionsfilter.includes(gtem.code))
			this.$emit("inputblur",e)
			},
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SalesTaxReport/index.less');
</style>
